import qs from 'qs';

/**
 * Escape unicode and encode to base64 string.
 */
export const b64DecodeUnicode = (str) =>
  decodeURIComponent(
    atob(str)
      .split('')
      .map((c) => `%${`00${c.charCodeAt(0).toString(16)}`.slice(-2)}`)
      .join(''),
  );

/**
 * Decode base64 string and unscape to unicode.
 */
export const b64EncodeUnicode = (str) =>
  btoa(
    encodeURIComponent(str).replace(/%([0-9A-F]{2})/g, (match, p1) =>
      String.fromCharCode(`0x${p1}`),
    ),
  );

/**
 * Compare stringified result of two objects.
 */
export const isStringEqual = (a, b) => JSON.stringify(a) === JSON.stringify(b);

/**
 * Wrap get item from local storage for unsupported targets.
 */
export const getLocalStorage = (key) => {
  try {
    return localStorage.getItem(key);
  } catch (error) {
    return null;
  }
};

/**
 * Wrap remove item from local storage for unsupported targets.
 */
export const removeLocalStorage = (key) => {
  try {
    localStorage.removeItem(key);
  } catch (error) {
    // localStorage is unavailable
  }
};

/**
 * Wrap set item to local storage for unsupported targets.
 */
export const setLocalStorage = (key, value) => {
  try {
    localStorage.setItem(key, value);
  } catch (error) {
    // localStorage is unavailable
  }
};

/**
 * Create uuid-like string.
 */
export const uuid = () =>
  /* eslint-disable no-bitwise, no-mixed-operators */
  'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c) => {
    const r = (Math.random() * 16) | 0;
    const v = c === 'x' ? r : (r & 0x3) | 0x8;
    return v.toString(16);
    /* eslint-enable no-bitwise, no-mixed-operators */
  });

/**
 * Wrap qs.stringify with default (overridable) options.
 */
export const stringifyQS = (object, options) =>
  qs.stringify(object, {
    indices: false,
    skipNulls: true,
    ...options,
  });

/**
 * Create an object with type string for each value, unless ignored.
 */
export const mapObjectToTypes = (obj, ignore = []) =>
  Object.keys(obj).reduce(
    (o, key) =>
      Object.assign(o, {
        [key]: ignore.includes(key)
          ? obj[key]
          : Object.prototype.toString.call(obj[key]),
      }),
    {},
  );
